import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@sunSource/Store/Data/CustomDataReducer";

(reducers as any).sunSourceState = customDataReducer;

type Reducers = {
    sunSourceState: typeof customDataReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
